import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";
var ls = new SecureLS({ isCompression: false});
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    Language:"fa",
    SEOFORM:{
      title:"",
      url:"",
      keywords:"",
      image:"",
      description:"",
      othermeta:""
    },
    User:{
      ua:"",
      ue:"",
      uln:"",
      un:"",
      up:""
    },
    LoggedIn:false,
    GalleryVideoChildUrl:""
  },
  mutations: {
    setSeoForm(state,data)
    {
      state.SEOFORM = data;
    },
    setGalleryVideoChild(state,data)
    {
      state.GalleryVideoChildUrl = data;
    },
    SetLang(state,data){
      state.Language = data;
    },
    SetLogin(state,data)
    {
      console.warn("USER DATA RECIVED :::::::::",data);
      state.LoggedIn = true;
      state.User = data;
    },
    SetLogoff(state)
    {
      state.LoggedIn = false;
      state.User = {
        ua:"",
        ue:"",
        uln:"",
        un:"",
        up:""
      };
      window.location.href = window.location.href;
    }
  },
  getters:{
    getSeoForm(state)
    {
      return state.SEOFORM;
    },
    getGalleryChild(state)
    {
      return state.GalleryVideoChildUrl;
    },
    GetLang(state){return state.Language;},
    GetUser(state){return state.User;},
    isLoggedIn(state){return state.LoggedIn;},
  },
  actions: {
    async setSeoForm({commit},payload)
    {
      commit('setSeoForm',payload)
    },
    async setGalleryVideoChild({commit},payload)
    {
      commit('setGalleryVideoChild',payload)
    },
    async SetLang({commit},payload)
    {
      commit('SetLang',payload);
    },
    async SetLogin({commit},payload)
    {
      commit('SetLogin',payload);
    },
    async SetLogoff({commit})
    {
      commit('SetLogoff');
    }
  },
  modules: {},
  plugins: [
    createPersistedState({
      storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key),
      },
    }),
  ],
});
